import React from 'react';

const DentalBiteLogo = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 200 50"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    data-testid="dentalBiteLogo"
    style={{
      fillRule: 'evenOdd',
      clipRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 2,
    }}
  >
    <g id="Artboard2" transform="matrix(3.88823,0,0,2.3121,-16.0815,-223.396)">
      <rect
        x="4.136"
        y="96.621"
        width="51.437"
        height="21.625"
        style={{ fill: 'none' }}
      />
      <g transform="matrix(0.176775,0,0,0.29728,11.2137,98.5891)">
        <path
          d="M60.9,27.3L60.9,0L73.1,0C81.7,0 88.1,4.9 88.1,13.6C88.1,22.3 81.7,27.3 73.2,27.3L60.9,27.3ZM69.2,20.1L73.1,20.1C77.2,20.1 79.7,17.1 79.7,13.6C79.7,9.9 77.6,7.2 73.2,7.2L69.2,7.2L69.2,20.1Z"
          style={{ fill: 'rgb(5,33,63)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.176775,0,0,0.29728,11.2137,98.5891)">
        <path
          d="M90.4,27.4L90.4,0L111.1,0L111.1,6.9L98.7,6.9L98.7,10.1L110.9,10.1L110.9,17L98.7,17L98.7,20.5L111.1,20.5L111.1,27.4L90.4,27.4Z"
          style={{ fill: 'rgb(5,33,63)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.176775,0,0,0.29728,11.2137,98.5891)">
        <path
          d="M131.8,27.3L121.7,12.6L121.7,27.3L113.4,27.3L113.4,0L121.9,0L131.4,13.8L131.4,0L139.7,0L139.7,27.3L131.8,27.3Z"
          style={{ fill: 'rgb(5,33,63)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.176775,0,0,0.29728,11.2137,98.5891)">
        <path
          d="M149.4,27.3L149.4,7.2L142.1,7.2L142.1,0L165,0L165,7.2L157.7,7.2L157.7,27.3L149.4,27.3Z"
          style={{ fill: 'rgb(5,33,63)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.176775,0,0,0.29728,11.2137,98.5891)">
        <path
          d="M181.6,27.3L180.5,23.8L170,23.8L168.9,27.3L159.9,27.3L170.1,0L180.5,0L190.6,27.3L181.6,27.3ZM175.3,7.3L172.2,16.9L178.4,16.9L175.3,7.3Z"
          style={{ fill: 'rgb(5,33,63)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.176775,0,0,0.29728,11.2137,98.5891)">
        <path
          d="M192.2,27.3L192.2,0L200.5,0L200.5,20.1L210.9,20.1L210.9,27.3L192.2,27.3Z"
          style={{ fill: 'rgb(5,33,63)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.176775,0,0,0.29728,11.2137,98.5891)">
        <path
          d="M60.9,59.5L60.9,32.1L77.5,32.1C83.1,32.1 85.6,35.9 85.6,39.1C85.6,42.5 83.6,44.8 80.9,45.4C83.8,45.9 86.1,48.6 86.1,52.1C86.1,55.9 83.5,59.5 78,59.5L60.9,59.5ZM69.2,42.3L75.6,42.3C76.5,42.3 77.2,41.5 77.2,40.5C77.2,39.6 76.4,38.8 75.6,38.8L69.2,38.8L69.2,42.3ZM69.2,52.7L75.8,52.7C77,52.7 77.7,51.9 77.7,50.9C77.7,49.9 77,49 75.8,49L69.2,49L69.2,52.7Z"
          style={{ fill: 'rgb(5,33,63)', fillRule: 'nonzero' }}
        />
        <rect
          x="87.5"
          y="32.1"
          width="8.3"
          height="27.3"
          style={{ fill: 'rgb(5,33,63)', fillRule: 'nonzero' }}
        />
        <path
          d="M105.4,59.4L105.4,39.3L98.1,39.3L98.1,32.1L121,32.1L121,39.3L113.7,39.3L113.7,59.4L105.4,59.4Z"
          style={{ fill: 'rgb(5,33,63)', fillRule: 'nonzero' }}
        />
        <path
          d="M123.3,59.5L123.3,32.1L144,32.1L144,39L131.6,39L131.6,42.2L143.8,42.2L143.8,49.1L131.6,49.1L131.6,52.6L144,52.6L144,59.5L123.3,59.5Z"
          style={{ fill: 'rgb(5,33,63)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.176775,0,0,0.29728,11.2137,98.5891)">
        <path
          d="M18.3,0L0,0L0,59.4L18.1,59.4C29.5,59.4 38.1,54.4 43.2,47.1C46.6,42.1 48.5,36 48.5,29.6C48.5,12.6 38.7,0 18.3,0ZM16,46.2L16,38C20.6,38 24.3,34.3 24.3,29.7C24.3,25.1 20.6,21.4 16,21.4L16,13.2C25.1,13.2 32.5,20.6 32.5,29.7C32.5,38.8 25.1,46.2 16,46.2Z"
          style={{ fill: 'rgb(5,33,63)', fillRule: 'nonzero' }}
        />
      </g>
    </g>
  </svg>
);

export default DentalBiteLogo;
